import { defineMessages } from 'react-intl';

export const sessionRecordingMessages = defineMessages({
  startTranscribing: {
    defaultMessage: 'Start transcribing',
    id: 'rqTGDjjsmb',
    description: 'Aria label for starting session transcription',
  },
  pauseTranscribing: {
    defaultMessage: 'Pause transcribing',
    id: 'F23hjtOZWr',
    description: 'Aria label for pausing session transcription',
  },
  resumeTranscribing: {
    defaultMessage: 'Resume transcribing',
    id: 'JkxXj2DRe4',
    description: 'Aria label for resuming session transcription',
  },
  stopTranscribing: {
    defaultMessage: 'Stop transcribing',
    id: 'D8shWQr373',
    description: 'Aria label for stopping session transcription',
  },
});
